const threshold = 0.25; // Le seuil d'intersection
const options = {
    root: null,
    rootMargin: '0px',
    threshold
};

// Fonction de gestion des intersections
const handleIntersect = function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.intersectionRatio > threshold) {
            console.log('Intersection détectée pour :', entry.target);
            entry.target.classList.add('reveal-loaded'); // Ajouter la classe "reveal-loaded"
            observer.unobserve(entry.target); // Arrêter d'observer cet élément
        }
    });
};

if ('IntersectionObserver' in window) {
    // Attendre le chargement complet de la page
    window.addEventListener("DOMContentLoaded", function () {
        // Initialiser l'observer
        const observer = new IntersectionObserver(handleIntersect, options);

        // Liste des sélecteurs
        const selectorsString = '.entry-content section, .wp-block-columns, .wp-block-image img, .entry-content p, button, a.btn, a.button, a.wp-block-button__link.wp-element-button';
        const selectors = selectorsString.split(',');

        // Ajouter la classe "reveal" aux éléments correspondants et les observer
        selectors.forEach(selector => {
            const targets = document.querySelectorAll(selector.trim()); // .trim() pour éviter les espaces superflus
            console.log(`Éléments trouvés pour "${selector}":`, targets);

            targets.forEach(target => {
                target.classList.add('reveal'); // Ajouter la classe "reveal"
                observer.observe(target); // Observer l'élément
            });
        });
    });
} else {
    // Gestion des navigateurs ne supportant pas IntersectionObserver
    console.error('IntersectionObserver non supporté par ce navigateur.');
}
